// extracted by mini-css-extract-plugin
module.exports = {"disabled":"Disabled_disabled__bAUG8","pulse":"Disabled_pulse__2CHlt"};